import { render, staticRenderFns } from "./allocationDemand.vue?vue&type=template&id=ae9772e0&"
import script from "./allocationDemand.vue?vue&type=script&lang=js&"
export * from "./allocationDemand.vue?vue&type=script&lang=js&"
import style0 from "./allocationDemand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports